export const WP_ENDPOINT = "http://city.georgievsk.ru/api/wp/wp/v2/";
export const ACF_ENDPOINT = "http://city.georgievsk.ru/api/wp/acf/v3/";

export const WP_SLIDER_PLACES = "slider_places";
export const WP_CITY_EVENTS = "city_events";
export const WP_CURRENT_PROJECT = "current_project";
export const WP_CITY_PROJECTS = "city_projects";
export const WP_CITY_PLACES = "city_places";
export const WP_LIBRARY_BOOKS = "books";
export const WP_LIBRARY_ALBUMS = "albums";

export const WP_CITY_FACTS = "city_facts";
export const WP_CITY_FORUM = "city_forum";

export const WP_CITY_EVENTS_PER_PAGE = 6;
export const WP_CITY_PROJECTS_PER_PAGE = 6;
export const WP_CITY_PROJECTS_COMMENTS_PER_PAGE = 15;
export const WP_CITY_PLACES_PER_PAGE = 6;
export const WP_CITY_FORUM_COMMENTS_PER_PAGE = 20;

export const GOOGLE_MAPS_TOKEN = "AIzaSyCe5tFGfKrAFwE_ojiLvRXyNwNFIFNn7xg";
export const FEEDBACK_PATH = "http://city.georgievsk.ru/api/feedback/";



// WEBPACK FOOTER //
// ./src/store/services/config.js